<template>
  <div class="container">
    <b-row align-h="center">
      <b-col lg="10" xl="8">
        <b-card class="mt-4 mb-4">
          <h4 class="font-weight-bold color-deeppink">Give a kudo</h4>
          <div v-if="error">
            {{error}}
          </div>
          <template v-else-if="!loading">
            <b-row class="justify-content-center align-items-center mt-5 mb-5">
              <template v-if="kudo">
                <b-col cols="auto">
                  <kudo-item :kudo="kudo" :selectable="true" :selected="true" />
                </b-col>
                <b-col cols="auto">
                  <b-icon-caret-right-fill font-scale="3" />
                </b-col>
              </template>
              <b-col cols="auto">
                <div class="p-3">
                  <div>
                    <avatar :src="photo" size="6rem" />
                  </div>
                  <div class="text-center font-weight-bold mt-2">
                    {{name}}
                  </div>
                </div>
              </b-col>
            </b-row>
            <kudo-recognition-form
              :receiver="receiver"
              :kudos="kudos"
              :submitting="submitting"
              @select-kudo="onKudoSelect"
              @submit="onGiveKudoSubmit"
            />
          </template>
          <div v-else class="text-center p-5">
            <b-spinner variant="primary" label="Loading..." />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BIconCaretRightFill } from 'bootstrap-vue'
import Avatar from '@/components/common/Avatar'
import KudoRecognitionForm from '@/components/forms/KudoRecognitionForm.vue'
import { KudoItem } from '@/components/KudosList'
import statuses from '@/helpers/statuses'
import { toastError, userName } from '@/helpers/helpers'

export default {
  name: 'KudosRecognition',

  computed: {
    ...mapGetters([
      'kudosLoading',
      'kudos'
    ]),

    key() {
      return this.$route.params.key
    },

    loading() {
      return this.kudosLoading === statuses.LOADING || this.loadingRecognition
    },

    name() {
      return this.receiver ? userName(this.receiver) : ''
    },

    photo() {
      return this.receiver ? this.receiver.photo : null
    }
  },

  data() {
    return {
      kudo: null,
      receiver: null,
      company: null,
      error: false,
      loadingRecognition: true,
      submitting: false
    }
  },

  mounted() {
    if (!this.key) {
      this.$router.replace({ name: 'ConnectToWorkspace' })
      return
    }

    this.$store.dispatch('fetchKudos')

    this.loadingRecognition = true
    this.$store.dispatch('kudoRecognition', this.key)
      .then(({ company, receiver }) => {
        this.company = company
        this.receiver = receiver
      })
      .catch(() => (this.error = 'Unexpected error'))
      .finally(() => (this.loadingRecognition = false))
  },

  methods: {
    onKudoSelect(id) {
      this.kudo = this.kudos.find(kudo => kudo.id === id)
    },

    onGiveKudoSubmit(data) {
      this.submitting = true
      this.$store.dispatch('sendKudoRecognition', { key: this.key, data })
        .then(() => {
          this.$router.replace({ name: 'ConnectToWorkspace' })
        })
        .catch(() => toastError(this))
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    Avatar,
    KudoItem,
    KudoRecognitionForm,
    BIconCaretRightFill
  }
}
</script>
